<section class="product-climatic" id="climaticCharacteristics">
  <h3 class="product-climatic__title">
    {{ 'products.specifications' | translate }}
  </h3>
  <div class="product-climatic__content">
    <!-- climatic properties items -->
    <div class="climatic-properties">
      <ul class="climatic-properties__group">
        <li class="property-item">
          <!-- climatic property name -->
          <h4 class="property-item__name">
            {{ 'products.density' | translate }}
            @if (climaticData()?.bulk_density?.unit) {
              <span class="property-item__unit">
                (
                {{
                  'enums.measurements.' + climaticData()?.bulk_density?.unit
                    | translate
                }}
                )</span
              >
            }
          </h4>
          <!-- climatic property value -->
          <p class="property-item__value">
            {{ climaticData()?.bulk_density?.value }}
          </p>
        </li>
        <li class="property-item">
          <!-- climatic property name -->
          <h4 class="property-item__name">
            {{ 'products.pressureResistance' | translate }}
          </h4>
          <!-- climatic property value -->

          <p class="property-item__value">
            @if (climaticData()?.pressure_resistance) {
              <span>
                {{ climaticData()?.pressure_resistance || '-' | translate }}
              </span>
            } @else {
              <span>-</span>
            }
          </p>
        </li>
        <li class="property-item">
          <!-- climatic property name -->
          <h4 class="property-item__name">
            {{ 'products.waterAbsorption' | translate }}
          </h4>
          <!-- climatic property value -->
          <p class="property-item__value">
            @if (climaticData()?.water_absorption) {
              <span>
                {{ climaticData()?.water_absorption || '-' | translate }}</span
              >
            } @else {
              <span>-</span>
            }
          </p>
        </li>
      </ul>

      <!-- other properties -->

      <div class="climatic-properties__other-property">
        <!-- climatic property name -->
        <h4 class="item-name">
          {{ 'products.acidResistance' | translate }}
        </h4>
        <!-- climatic property value -->
        <p class="item-value">
          {{ climaticData()?.acid_resistance }}
        </p>
      </div>

      <div class="climatic-properties__other-property">
        <!-- climatic property name -->
        <h4 class="item-name">
          {{ 'products.frostResistance' | translate }}
        </h4>
        <!-- climatic property value -->
        <p class="item-value">
          @if (climaticData()?.frost_resistance) {
            <span>
              {{ climaticData()?.frost_resistance || '-' | translate }}</span
            >
          } @else {
            <span>-</span>
          }
        </p>
      </div>
    </div>

    <div></div>
    <!-- climatic formula -->
    <div class="climatic-formula">
      <h4 class="climatic-formula__name">
        {{ 'products.chemicalFormula' | translate }}
      </h4>
      <p class="climatic-formula__value">
        {{ climaticData()?.chemical_formula }}
      </p>
    </div>
  </div>
</section>
